import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'ui';

const EmailReply = ({ answerText, questionData }) => (
  <>
    <div className="bdrs-base bg-white p-24 mt-24 mb-24 bs-2">
      <span className="d-f ai-fs mb-16">
        <Icon name="user" className="mr-16 mt-8" />
        <span className="d-f fd-c">
          <span className="fw-b fz-14">{questionData.from}</span>
          <span className="fz-12">{`${t(
            'questions.question.email_reply.time_stamp',
          )}`}</span>
        </span>
      </span>
      <div className="fz-14 fw-b mb-32">{questionData.subject}</div>
      <div className="fz-16 ws-pl">{questionData.body}</div>
    </div>
    <span className="fw-b mt-24 fz-16">{t('questions.question.response')}</span>
    <div className="Card p-32 mt-24">
      <span className="fz-16 fs-i border-left-solid border-left-1 border-gray pl-16">
        {answerText}
      </span>
    </div>
  </>
);

EmailReply.propTypes = {
  answerText: PropTypes.string,
  questionData: PropTypes.shape({
    body: PropTypes.string,
    from: PropTypes.string,
    subject: PropTypes.string,
  }),
};

export default EmailReply;
